import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { filter, switchMap, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'app-resizable',
  templateUrl: './resizable.component.html',
  styleUrls: ['./resizable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResizableComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() key: string;
  @Input() isFlex: boolean;
  @Input() width: number;
  @Input() min: number = 32;
  @Input() isResize: boolean;
  @Input() isLast: boolean = false;
  @Input() listElem: HTMLElement;
  @Output() changedWidth = new EventEmitter();

  private destroyed$ = new Subject();
  diffWidth: number;
  startMovePos: number | null = null;

  @ViewChild('box') public box: ElementRef;
  @ViewChild('resizeAction') public resizeAction: ElementRef;

  private resize(x: number) {
    if (this.startMovePos === null) {
      this.startMovePos = x;
    } else {
      this.startMovePos = this.box.nativeElement.getBoundingClientRect().right;
    }

    if (!this.diffWidth) {
      this.diffWidth = this.box.nativeElement.offsetWidth;
    }

    const diff = x - this.startMovePos;
    const w = this.diffWidth + diff;

    if (w > this.min) {
      this.diffWidth = w;
    }
  }

  private initListeners() {
    const mouseDown$ = fromEvent<MouseEvent>(this.resizeAction.nativeElement, 'mousedown').pipe(
      filter((event) => event.button === 0)
    );
    const mouseMove$ = fromEvent<MouseEvent>(this.listElem, 'mousemove');
    const mouseUp$ = fromEvent(document, 'mouseup').pipe(
      tap(() => {
        if (this.diffWidth > this.min) {
          this.changedWidth.emit(this.diffWidth);
        }

        this.startMovePos = null;
      })
    );

    mouseDown$
      .pipe(
        switchMap(() => mouseMove$.pipe(takeUntil(mouseUp$))),
        takeUntil(this.destroyed$)
      )
      .subscribe((e) => {
        this.resize(e.clientX);

        if (this.diffWidth > this.min) {
          this.changedWidth.emit(this.diffWidth);
        }
      });
  }

  ngOnChanges(data: SimpleChanges): void {
    this.diffWidth = data?.width?.currentValue;
  }

  ngAfterViewInit() {
    if (this.min && this.isResize) {
      this.initListeners();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  constructor() {}
}
